import _ from 'lodash';
import {
  step6ExpenseLookup,
  step7ExpenseLookup,
  step8ExpenseLookup,
  step9ExpenseLookup,
  step10ExpenseLookup,
  step11ExpenseLookup,
  convertClaimCode,
} from '../dataMapper/claimCodeMapper';

export const mapDataForClaimType = (data, policyTypeId) => {
  const tmp = convertClaimCode([...data], policyTypeId);
  for (let i = 0; i < tmp.length; i++) {
    const isStep6 = (step6ExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStep7 = (step7ExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStep8 = (step8ExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStep9 = (step9ExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStep10 = (step10ExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    const isStep11 = (step11ExpenseLookup.claimCodeList.filter((d) => d === tmp[i].claimCode)).length > 0;
    if (isStep6) {
      tmp[i].step = 6;
      tmp[i].description = 'Trip Cancellation and Additional Expenses';
      tmp[i].position = 3;
      tmp[i].codeList = step6ExpenseLookup.claimCodeList;
    } else if (isStep7) {
      tmp[i].step = 7;
      tmp[i].description = 'Personal Items';
      tmp[i].position = 2;
      tmp[i].codeList = step7ExpenseLookup.claimCodeList;
    } else if (isStep8) {
      tmp[i].step = 8;
      tmp[i].description = 'Overseas Medical';
      tmp[i].position = 1;
      tmp[i].codeList = step8ExpenseLookup.claimCodeList;
    } else if (isStep9) {
      tmp[i].step = 9;
      tmp[i].description = 'Rental Vehicle';
      tmp[i].position = 4;
      tmp[i].codeList = step9ExpenseLookup.claimCodeList;
    } else if (isStep10) {
      tmp[i].step = 10;
      tmp[i].description = 'Snow Sports';
      tmp[i].position = 5;
      tmp[i].codeList = step10ExpenseLookup.claimCodeList;
    } else if (isStep11) {
      tmp[i].step = 11;
      tmp[i].description = 'Other';
      tmp[i].position = 6;
      tmp[i].codeList = step11ExpenseLookup.claimCodeList;
    }
  }

  return _.remove(_.uniqBy(tmp, 'step'), (d) => !!d.step);
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step5/mapDataForClaimType.js